import { staleDesignAssetError } from '../api/assets';

/** Owns the latest-wins contract for async design preparation. */
export class DesignSelectionGuard {
  private generation = 0;

  begin(): number { this.generation += 1; return this.generation; }
  cancel(): void { this.generation += 1; }
  isCurrent(operation: number): boolean { return operation === this.generation; }
  assertCurrent(operation: number): void {
    if (!this.isCurrent(operation)) throw staleDesignAssetError();
  }
}
